const types = {
    electronic: {
        noun: 'e-ticket',
        nounPlural: 'e-tickets'
    },
    hard: {
        noun: 'Hard ticket',
        nounPlural: 'Hard tickets'
    },
    instant: {
        noun: 'Instant Download ticket',
        nounPlural: 'Instant Download tickets'
    },
    flash: {
        noun: 'Flash Seat ticket',
        nounPlural: 'Flash Seat tickets'
    },
    paperless: {
        noun: 'Paperless ticket',
        nounPlural: 'Paperless tickets'
    },
    mobile: {
        noun: 'Mobile ticket',
        nounPlural: 'Mobile tickets'
    }
}

export default {
    types
}
